/**
 * Internal dependencies
 */
import { getEditedLayout } from 'state/dashboard-layouts/selectors';
import saveDashboardLayout from './save-dashboard-layout';

export default (layoutId) => (dispatch, getState) => {
	const layout = getEditedLayout(getState(), layoutId);
	if (layout) {
		return dispatch(saveDashboardLayout(layoutId, layout));
	}
};
